import React, { useEffect, useState } from 'react'
import Button from '../../../../component/Button';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import classes from './style.module.scss';
import ResourceDetails from './ResourceDetails';
import ResourceBrief from './ResourceBrief';
import ResourceDisplay from './ResourceDisplay';
import { Toast } from '../../../../service/toast';
import request from '../../../../service';
import Exported from '../../../../service/endpoints';
import { ActiveStatus, ActiveStatusColor } from '../../../../helpers';

const ViewResources = (props) => {

    const { title, resourceId, handleDelete } = props
    const [resourseInfo, setResourseInfo] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (resourceId) {
            getDetails(resourceId)
        }
    }, [resourceId])

    const getDetails = async (id) => {
        let url = `${Exported.Endpoints.getResourcesByID}/${id}`
        let paramsObj = {
            id: id,
        }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                setResourseInfo(res?.data?.data)
            } else {
                setResourseInfo(null)
            }
        }).catch((err) => {
            console.log(err, "err")
            setResourseInfo(null)
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const redirectBack = () => {
        navigate('/admin/resources')
    }

    const redirectTo = () => {
        navigate(`?type=edit?id=${resourceId}`)
    }

    return (
        <>
            <div className={``}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title flex items-center`}>
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                        </div>
                        <div>{title} Details</div>
                        <div className={classes.successRole} style={{ background: `${ActiveStatusColor[resourseInfo?.status]}20`, color: ActiveStatusColor[resourseInfo?.status] }}>{ActiveStatus[resourseInfo?.status]}</div>
                    </div>
                    <div className='flex items-center'>
                        {/* <Button text={"Download"} className={`mr-4`} smallBtn secondary /> */}
                        <Button text={"Delete"} className={`mr-4 !w-[100px]`} smallBtn secondary onClick={() => handleDelete(resourceId)} />
                        <Button text={"Edit"} className={`!w-[100px]`} smallBtn secondary onClick={() => redirectTo()} />
                    </div>
                </div>
                <div className='my-8'>
                    <ResourceDetails resourseInfo={resourseInfo} />
                    <ResourceBrief resourseInfo={resourseInfo} />
                    <ResourceDisplay resourseInfo={resourseInfo} />
                </div>
            </div>
           
        </>
    )
}

export default ViewResources